module.exports = __webpack_public_path__ + "img/table.4f8e26d0.png";